var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarning24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.warning24{fill:currentColor;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "warning24",
    d: "M11.99,9.2c0.41,0,0.75,0.34,0.75,0.75v4.3c0,0.41-0.34,0.75-0.75,0.75s-0.75-0.34-0.75-0.75v-4.3 C11.24,9.54,11.57,9.2,11.99,9.2z M11.99,17.15c-0.55,0-1,0.45-1,1s0.45,1,1,1s1-0.45,1-1S12.54,17.15,11.99,17.15z M22.92,21.89 c-0.13,0.23-0.38,0.37-0.64,0.37H1.77c-0.26,0-0.51-0.14-0.64-0.37c-0.14-0.23-0.14-0.51-0.02-0.74L11.36,2.13 c0.26-0.49,1.06-0.49,1.32,0l10.25,19.02C23.06,21.39,23.05,21.67,22.92,21.89z M21.02,20.76l-9-16.69L3.03,20.76H21.02z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning24);
export default __webpack_public_path__ + "static/media/icon_warning-24.a1d195fe1069877eb17b9ba3af8dab5a.svg";
export { ForwardRef as ReactComponent };